import { Guide } from './types';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetGuideRequestOption = CommonRequestOptions & {
   unpatrolled?: boolean;
   releaseid?: number | null;
   useSourceLang?: boolean;
   includeComments?: boolean;
};

export async function getGuide(
   guideid: number | null,
   {
      unpatrolled = false,
      releaseid = null,
      useSourceLang = false,
      includeComments = false,
      ...common
   }: GetGuideRequestOption = {}
): Promise<Guide | null> {
   if (guideid === null) return null;
   return makeRequest('get', `guides/${guideid}`, {
      ...common,
      query: {
         unpatrolled,
         releaseid,
         useSourceLang,
         includeComments,
      },
   });
}
